import ReactPlayer from 'react-player'
import { Link } from 'react-router-dom'
import Button from '../components/ui/Button'
import Title from '../components/ui/Title'
import '../styles/ui/ui.scss'
import '../styles/pages/top.scss'

import { useState, useEffect } from 'react'

const TARGET_TIME = new Date('2026-09-10T09:00:00-07:00').getTime();

const Top = ({ isReleased }) => {
    const [thumbnail, hideThumbnail] = useState(false)

    
    const [isRevealed, setIsRevealed] = useState(() => Date.now() >= TARGET_TIME);

    useEffect(() => {
        if (isRevealed) return;

        const timeRemaining = TARGET_TIME - Date.now();

        // Set a single timeout for the exact delay instead of polling
        const timer = setTimeout(() => {
        setIsRevealed(true);
        }, timeRemaining);

        return () => clearTimeout(timer);
    }, [isRevealed]);

    return (
        <div className='page-container'>
            <section className='top-hero'>
                <div className='hero-wrapper chara-img'>
                    <div className='top-hero_contents'>
                        <div className='img-wrapper'>
                            <img
                                src={`./img/${isReleased ? 'zero_logo_launch' : 'zero_logo_rda'}.png`}
                                alt='Trails from Zero Logo and Release Date'
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className='top-main'>
                <Title text='Overcome the odds and seize the truth!' size='full' />
                <div className='top-info_wrapper'>
                    <div className='info'>
                        <p>
                            When Lloyd Bannings is assigned to Crossbell's Special Support Section, he and his new
                            teammates must prove themselves as they fight to overcome injustice in a city gripped by
                            corruption.
                        </p>
                        <Link to='/story'>
                            <Button text='Story Page' type='gradient' color='red' />
                        </Link>
                    </div>
                    <img src='./img/world/crossbell-city.webp' alt='City of Crossbell' />
                </div>
                <div className='top-card_list'>
                    <Link to='/character'>
                        <TopCard text='Characters' image={`./img/bg/characters-card.webp`} />
                    </Link>
                    <Link to='/world'>
                        <TopCard text='World' image={`./img/bg/map-bg.webp`} />
                    </Link>
                    <Link to='system'>
                        <TopCard text='System' image={`./img/bg/tech-bg.webp`} />
                    </Link>
                </div>
                <div className='video-container'>
                    <h1 className='lead-title'>{
                        isReleased ? 'Launch Trailer' : 'Release Date Announcement Trailer'    
                    }</h1>
                    <div className='video-wrapper'>
                        {thumbnail ? (
                            <ReactPlayer url={
                                isReleased ? 'https://www.youtube.com/watch?v=4vUj0nlTlGA' : 'https://www.youtube.com/watch?v=XHpTVUikuO0'
                            } />
                        ) : (
                            <div className='youtube-thumb-wrapper'>
                                <p>PLAY</p>
                                <img
                                    src={
                                        isReleased ? 'https://i3.ytimg.com/vi/4vUj0nlTlGA/maxresdefault.jpg' : './img/rda_trailer_thumb.webp'
                                    }
                                    alt='The Legend of Heroes Trails From Zero Announcement Trailer'
                                    className='youtube-thumb'
                                    onClick={() => {
                                        hideThumbnail(true)
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    )
}

const TopCard = ({ text, body, image }) => (
    <div
        className='top-card'
        style={{
            backgroundImage: `linear-gradient(rgba(39, 112, 172, 0.47), rgba(39, 112, 172, 0.47)), url(${image})`,
        }}
    >
        <div className='text-wrapper'>
            <h1>{text}</h1>
        </div>
    </div>
)

export default Top
